import { UtilityService } from '../utility.service';
import { BannerListenerService } from './banner-listener.service';
import { ConfigService } from './config.service';
import { DataService } from './data.service';
import { Consent } from '../../dataTypes/type-consent';
/**
 * This class provide custom functions from setting app.
 */
export class CustomFunctionsService {
	private utilityService: UtilityService;
	private _consentParamsForLocalstorage = [];
	private _isStoreToDataLayer = false;
    private _dataLayerListenerData: any;
    static htmlTransitionInProgress: boolean = false;
    static ownPositionSet: boolean = false;

    constructor(utilityService) {
        this.utilityService = utilityService;
        this.acceptConsentsOutsideBannerClick = this.acceptConsentsOutsideBannerClick.bind(this);
        this.acceptConsents = this.acceptConsents.bind(this);
        this.dataLayerListener = this.dataLayerListener.bind(this);
    }

	/**
	 * @Dave
	 * window eventslistener for special events
	 */
	activateFunctionsOnEventsListener() {
		const self = this;
		if (
			this.utilityService.settingsService.settings.activateFunctionsOnEvents &&
			this.utilityService.settingsService.settings.activateFunctionsOnEvents
				.length
		) {
			this.utilityService.settingsService.settings.activateFunctionsOnEvents.forEach(
				element => {
					switch (element.function) {
					case '1':
						this.processImplicitConsentFunction(element);
					case '2':
						if (element.params && element.params.length) {
							this._dataLayerListenerData = element;
							this._dataLayerListenerData.dataLayer = [];
							this._dataLayerListenerData.variables = [];
							element.params.forEach(param => {
								const data = param.split('.');
								if (
									this._dataLayerListenerData.dataLayer.indexOf(data[0]) ===
										-1
								) {
									this._dataLayerListenerData.dataLayer.push(data[0]);
									data.splice(0, 1);
									this._dataLayerListenerData.variables.push(data);
								}
							});
							this.utilityService.developmentLog(
								'setting dataLayer',
								this._dataLayerListenerData
							);
							this._dataLayerListenerData.dataLayer.forEach(
								gDataLayers => {
									if (window[gDataLayers]) {
										this.utilityService.developmentLog(
											'listening to DataLayerHelper',
											gDataLayers
										);
										new window['DataLayerHelper'](
											window[gDataLayers],
											this.dataLayerListener,
											true
										);
									} else {
										this.utilityService.developmentLog(
											'not listening to DataLayerHelper because cannot finde global object for',
											gDataLayers
										);
									}
								}
							);
						}
						break;
					case '3':
						if (element.params && element.params.length) {
							if (element.event === 'onInitializeAndChangeConsent') {
								this._consentParamsForLocalstorage = element.params;
								this.storeConsentStatusToLocalStorage();
							}
						}
						break;
					case '4':
						if (element.event === 'onInitializeAndChangeConsent') {
							this._isStoreToDataLayer = true;
							this.storeEventToLocalStorage();
						}
						break;
					case '5':
						if (element.event === 'onBannerOpen') {
							if (document.readyState === 'complete') {
								setTimeout(() => {
									this.setSVGPosition(element.params);
								}, 3000);
							} else {
								window.addEventListener('load', () => {
									setTimeout(() => {
										this.setSVGPosition(element.params);
									}, 3000);
								});
							}
						}
						break;
					case '6':
                        const hideBanner = true;
                        this.processImplicitConsentFunction(element, hideBanner);
						break;
					case '7':
						if (
							!this.utilityService.settingsService.firstUserInteraction
								.stateSaved
						) {
							this.adjustBodyPadding();
						}
						break;
					default:
						break;
					}
				}
			);
		}
    }
    
    /**
     * Binds the handler for click to accepting consents if
     * - is a first time user for whom we need a consent
     * - implicit consents are not deactived by config
     */
    private processImplicitConsentFunction = (element, hideBanner?) => {
        if (
            !element.params.length &&
            !this.utilityService.settingsService.firstUserInteraction
                .stateSaved &&
            !ConfigService.areImplicitConsentsDeactivated()
        ) {
            const self = this;
            window.addEventListener(
                element.event,
                hideBanner ? self.acceptConsents : self.acceptConsentsOutsideBannerClick,
                false
            );
        }
    }

    adjustBodyPadding() {
        if (
            this.utilityService.settingsService.settings.activateFunctionsOnEvents
                .map(function (e) {
                    return e.function;
                })
                .indexOf('7') === -1
        ) {
            return;
        }
        const bannerHeight = BannerListenerService.bannerHeight + 'px';
        const elementCollection = document.getElementsByTagName('html');
        // Safeguard in case something goes wrong
        if (elementCollection.length !== 1) {
            return;
        }

        const htmlElement = elementCollection[0];
        if (this.utilityService.settingsService.settings.bannerPlacement === 2) {
            if (htmlElement.style.paddingTop === bannerHeight) {
                return;
            }
            htmlElement.style.paddingTop = bannerHeight;
        } else {
            if (htmlElement.style.paddingBottom === bannerHeight) {
                return;
            }
            htmlElement.style.paddingBottom = bannerHeight;
            htmlElement.style.height = "auto";
            htmlElement.style.minHeight = "auto";
        }

        if (!CustomFunctionsService.htmlTransitionInProgress) {
            CustomFunctionsService.htmlTransitionInProgress = true;
            const originalCssTransition = htmlElement.style.transition;

            // This is important to stop absultely positioned elements from positioned on HTML rather then BODY
            let removePosition = false;
            if (!document.body.style.position) {
                document.body.style.position = 'relative';
                CustomFunctionsService.ownPositionSet = true;
            } 

            // In case the banner was removed, 
            if (bannerHeight === '0px' && CustomFunctionsService.ownPositionSet === true) {
                removePosition = true;
            }

            // Set a CSS transition to padding top and bottom to animate the content push
            htmlElement.style.transition = 'padding-top .5s ease-out, padding-bottom .5s ease-out';
    
            // Remove the transition after 500ms to not interfere with clients page
            window.setTimeout(() => {
                htmlElement.style.transition = originalCssTransition;
                CustomFunctionsService.htmlTransitionInProgress = false;
                // Also remove CSS position on the body if necessary
                if (removePosition) {
                    document.body.style.position = null;
                }
            }, 500);
        }
    }

	setSVGPosition(param) {
		param.forEach((element, index) => {
			if (index === 0) {
				var copyDiv = document.getElementById(param);
				var pasteDiv = document.getElementById('uc-fingerprint-icon-overlay');
				if (copyDiv && pasteDiv) {
					// get position of fingerprint icon on website
					var rect = copyDiv.getBoundingClientRect();
					this.utilityService.UserCentricViewController.bannerModalController.setBanner12SpecialSvg(
						rect
					);
					// set position of fingerprint icon in banner-modal overlay
					pasteDiv.style.left = rect.left + 'px';
					pasteDiv.style.top = rect.top + 'px';
					pasteDiv.style.right = rect.right + 'px';
					pasteDiv.style.bottom = rect.bottom + 'px';
					pasteDiv.style.width = rect.right - rect.left + 'px';
					pasteDiv.style.height = rect.bottom - rect.top + 'px';
					pasteDiv.style.display = 'block';

					pasteDiv.onclick = () => {
						window.usercentrics.toggleCornerModalIsVisible();
					};
				}
			}
		});
	}

	storeEventToLocalStorage() {
		const consentsInLocalstorage: Consent.Consent[] = DataService.getConsentsFromLocalStorage(
			'consents'
        );
        const templates: Consent.ConsentTemplates = DataService.getConsentsFromLocalStorage(
			'consentTemplates'
        );
		const dataLayer = {};
		if (consentsInLocalstorage && this._isStoreToDataLayer) {
			consentsInLocalstorage.forEach(consent => {
                const template = templates[consent.templateId][consent.version];
                if (!template) {
                    console.error('consent ' + consent.templateId + ' version ' + consent.version + ' not found');
                }
				dataLayer[template.dataProcessors[0]] = consent.consentStatus;
			});
			localStorage.setItem('dataLayer', JSON.stringify(dataLayer));
		}
	}

	storeConsentStatusToLocalStorage() {
		var consentsInLocalstorage = DataService.getLocalStorage(
			'consents'
		);
		var consents = [];
		if (
			consentsInLocalstorage &&
			this._consentParamsForLocalstorage &&
			this._consentParamsForLocalstorage.length
		) {
			consentsInLocalstorage.forEach(consent => {
				var data = {};
				this._consentParamsForLocalstorage.forEach(param => {
					if (consent.hasOwnProperty(param)) {
						data[param] = consent[param];
					}
				});
				consents.push(data);
			});
			localStorage.setItem('consents', JSON.stringify(consents));
		}
	}

	dataLayerListener(model, message) {
		this.utilityService.developmentLog('inside dataLayer listner');
		this._dataLayerListenerData.variables.forEach(element => {
			const vars = JSON.parse(JSON.stringify(element));
			var data = message;

			/** 
			 * this.developmentLog(
			 * trying to find ${JSON.stringify(
			 * vars
			 * )} in dataLayer triggered by event `,
			 * message.event
			 * );
			 */
			while (vars.length) {
				if (data[vars[0]]) {
					data = data[vars[0]];
					vars.splice(0, 1);
				} else {
					return;
				}
			}
			if (data && this._dataLayerListenerData.function === '2') {
				this.updateCurrentLanguageDisplayedToUser(data);
			}
		});
	}

	updateCurrentLanguageDisplayedToUser(data) {
		this.utilityService.developmentLog(
			'updating language from custom function',
			data
		);
		if (this.utilityService.languageService) {
			this.utilityService.languageService.setLanguage(data);
		}
	}

	acceptConsents($event) {
		this.acceptConsentsOutsideBannerClick($event, true);
	}

	acceptConsentsOutsideBannerClick($event, hideBanner?) {

        // Check if click was done on any embed element
        const embedElement = document.getElementsByClassName('uc-embed');
        for (let i = 0; i < embedElement.length; i++) {
            if (embedElement[i].contains($event.target)) {
                return;
            }
        }

        const wrapper = document.getElementById('usercentrics-button');
		if (
			$event.target.id !== 'uc-btn-accept-banner' &&
			$event.target.id !== 'uc-btn-deny-banner' &&
			$event.target.id !== 'uc-btn-more-info-banner' &&
			!wrapper.contains($event.target)
		) {
            /** Only change consents if it is first interaction. In case of cdcs this state
             *  might be set to true, after the listener was attached
             */
            if (!this.utilityService.settingsService.firstUserInteraction.stateSaved) {
                const action = 'onSpecialFunctionAcceptAllConsentTrigger';
                const updatedBy = 'implicit';
                this.utilityService.saveConsentsService.acceptAllConsents(
                    action,
                    updatedBy
                );
            }
			if (hideBanner) {
				this.utilityService.settingsService.saveFirstUserInteraction();
				this.utilityService.settingsService.bannerIsVisible = false;
				this.utilityService.UserCentricViewController.updateView();
			}
			this.utilityService.settingsService.settings.activateFunctionsOnEvents.forEach(
				element => {
					window.removeEventListener(
						element.event,
						hideBanner
							? this.acceptConsents
							: this.acceptConsentsOutsideBannerClick,
						false
					);
				}
			);
		}
	}
}
